



















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
import WarehousesPlanForm from '../WarehousesPlanForm/WarehousesPlanForm.vue'
import WarehousesExportToCRMForm from '../WarehousesExportToCRMForm/WarehousesExportToCRMForm.vue'

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapGetters(STORE_KEY, [
      'total', 'groupedRows'
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'meta', 'days',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar,
  }
})
export default class WarehousesDoneList extends Vue {
  public warehouse_id: any = null;
  public dates: any = null;
  public actor!: any;
  public visibleQuantity: boolean = false;

  mark_value: any = {
    null: {label: 'отлично', color: '#FFFFFF'},
    '1': {label: 'отлично', color: '#00AA00'},
    '2': {label: 'хорошо', color: '#FFFF00'},
    '3': {label: 'повышенное внимание', color: '#FFAA00'},
    '4': {label: 'карантин', color: '#FF0000'},
  }

  get titleStack () {
    return [
      'Склад готовой продукции'
    ]
  }

  openPlanDocument(row: any) {
    this.$buefy.modal.open({
      component: WarehousesPlanForm,
      props: {
        isNew: !row || !row.plan_id,
        fromState: 'done',
        documentPreview: {
          id: row.plan_id,
        },
        documentId: row.plan_id,
        initParams: {
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openExportToCRMForm(row: any) {
    this.$buefy.modal.open({
      component: WarehousesExportToCRMForm,
      props: {
        isNew: !row || !row.plan_id,
        documentPreview: row,
        initParams: {
          container_weight: parseFloat(row.container_weight || row.fact_container_weight),
          shift_atom_plan_id: (row.line_template == 'atom' ? row.plan_id : null),
          shift_custom_plan_id: (row.line_template !== 'atom' ? row.plan_id : null),
          line_template: row.line_template,
          product_container_id: row.product_container_id,
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }
  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  
  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }

}
